import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { memo } from 'react';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ModalConfirmNotificationProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onYes: () => void;
  numberNotification?: number;
}

const ModalConfirmNotificationComponent = ({
  open,
  onClose,
  onYes,
  numberNotification,
}: ModalConfirmNotificationProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        {`Stai approvando ${numberNotification} notifiche`}
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" type="button" onClick={() => onYes()}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalConfirmNotificationComponent.displayName = 'Modal Confirm Notification';

const ModalConfirmNotification = memo(ModalConfirmNotificationComponent);

export default ModalConfirmNotification;
